import React, { useState } from 'react';
import { Modal } from './Modal';
import { updateProduct } from '../lib/db';

interface EditProductModalProps {
  product: any;
  isOpen: boolean;
  onClose: () => void;
  onUpdate: () => void;
  onStatusChange?: (id: number, status: string) => void;
  showStatusChange?: boolean;
  currentStatus?: string;
}

export function EditProductModal({ 
  product, 
  isOpen, 
  onClose, 
  onUpdate,
  onStatusChange,
  showStatusChange = false,
  currentStatus
}: EditProductModalProps) {
  const [editingProduct, setEditingProduct] = useState({
    clientNumber: product.client_number,
    description: JSON.parse(product.items).join('\n'),
    manualTotal: product.total_price
  });

  const handleSave = async () => {
    const items = editingProduct.description
      .split('\n')
      .filter(item => item.trim());

    await updateProduct(product.id, {
      ...editingProduct,
      items,
      totalPrice: parseFloat(editingProduct.manualTotal)
    });
    onUpdate();
    onClose();
  };

  const getStatusButtonText = () => {
    switch (currentStatus) {
      case 'draft': return 'Marquer comme en cours';
      case 'pending': return 'Remettre en brouillon';
      case 'completed': return 'Remettre en cours';
      default: return 'Changer le statut';
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Modifier le produit">
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Numéro de Client
          </label>
          <input
            type="text"
            value={editingProduct.clientNumber}
            onChange={(e) => setEditingProduct({
              ...editingProduct,
              clientNumber: e.target.value
            })}
            className="w-full p-2 border rounded-md"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            value={editingProduct.description}
            onChange={(e) => setEditingProduct({
              ...editingProduct,
              description: e.target.value
            })}
            className="w-full p-2 border rounded-md"
            rows={6}
            placeholder="Description libre des articles..."
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Prix Total Final
          </label>
          <input
            type="number"
            value={editingProduct.manualTotal}
            onChange={(e) => setEditingProduct({
              ...editingProduct,
              manualTotal: e.target.value
            })}
            className="w-full p-2 border rounded-md"
            step="0.01"
          />
        </div>

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
          >
            Annuler
          </button>
          {showStatusChange && onStatusChange && (
            <button
              onClick={() => {
                onStatusChange(product.id, 'draft');
                onClose();
              }}
              className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
            >
              {getStatusButtonText()}
            </button>
          )}
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            Sauvegarder
          </button>
        </div>
      </div>
    </Modal>
  );
}